<ng-container *ngIf="!isLoading">
  <div class="filters-box">
    <div class="row">
      <div class="col filter-box period-filter-col">
        <app-filter-item
          [filterTitle]="periodFilterMobileTitle"
          [filterItems]="periodFilterItems"
          [disabled]="disabled"
          (setValue)="periodFilterChangeEvent($event)"
        />
      </div>
      <div class="col filter-box type-filter-col">
        <app-filter-item
          [filterTitle]="typeFilterMobileTitle"
          [filterItems]="typeFilterItems"
          [disabled]="disabled"
          (setValue)="typeFilterChangeEvent($event)"
        />
      </div>
    </div>
  </div>

  <div class="search-box">
    <mat-form-field appearance="outline" class="mb-0">
      <input matInput [placeholder]="searchPlaceholder" [value]="searchValue" (input)="onKeySearch($event)" [disabled]="disabled">
      <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
    </mat-form-field>
  </div>
</ng-container>

<ng-container *ngIf="isLoading">
  <div class="filters-box">
    <div class="row">
      <div class="col filter-box period-filter-col">
        <app-filter-item [isLoading]="isLoading"/>
      </div>

      <div class="col filter-box type-filter-col">
        <app-filter-item [isLoading]="isLoading"/>
      </div>
    </div>
  </div>

  <div class="search-box">
    <app-skeleton [height]="48"/>
  </div>
</ng-container>